__turbopack_context__.v({
  "button": "teams-purchase-content-module-scss-module__n8VWtq__button",
  "checkbox-icon": "teams-purchase-content-module-scss-module__n8VWtq__checkbox-icon",
  "container": "teams-purchase-content-module-scss-module__n8VWtq__container",
  "description": "teams-purchase-content-module-scss-module__n8VWtq__description",
  "list": "teams-purchase-content-module-scss-module__n8VWtq__list",
  "logo": "teams-purchase-content-module-scss-module__n8VWtq__logo",
});
